import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { MAIN_URL } from "../../../Configurations/Urls";
import AuthShell from "../../../Components/Auth/AuthShell";

const SpinSVG = () => (
  <svg width="18" height="18" viewBox="0 0 15 15" fill="none"
    style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}>
    <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor" strokeOpacity=".3" strokeWidth="2.5" fill="none" />
    <path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
  </svg>
);

function ForgotPassword({
  title = "Forgot Password",
  appName = "HR ERP Core",
  description,
}) {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const sendOtp = async (e) => {
    e.preventDefault();
    let formErrors = {};
    setErrors({});

    if (!email) {
      formErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      formErrors.email = "Invalid email format";
    }

    if (Object.keys(formErrors)?.length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${MAIN_URL}/api/auth/forgot-password`, { email },  { headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },});
      toast.success(res.data.message);
      setOtpSent(true);
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to send OTP. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    let formErrors = {};
    setErrors({});

    if (!enteredOtp) {
      formErrors.otp = "OTP is required";
    } else if (!/^[0-9]{6}$/.test(enteredOtp)) {
      formErrors.otp = "Invalid OTP format";
    }

    if (Object.keys(formErrors)?.length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${MAIN_URL}/api/auth/verified-otp`, {
        email,
        otp: +enteredOtp,
      });
      toast.success(res.data.message || "OTP verified!");
      navigate("/reset-password", { state: { email } });
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to verify OTP. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={otpSent ? "Verify OTP" : title}
      subtitle={otpSent ? "Enter the 6-digit code sent to your email." : "We’ll send a verification code to your email."}
      appName={appName}
      description={description}
    >
      {!otpSent ? (
        <form onSubmit={sendOtp} noValidate>
          <div className="ems-auth-field">
            <label htmlFor="forgot-email">Email Address</label>
            <input
              id="forgot-email"
              placeholder="name@company.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ems-fm-input"
            />
            {errors.email && <span className="ems-fm-err">{errors.email}</span>}
          </div>
          <div className="ems-auth-actions">
            <button type="submit" className="ems-btn ems-primary" disabled={loading}>
              {loading ? <><SpinSVG /> Sending…</> : "Send OTP"}
            </button>
            <Link to="/login" className="ems-auth-forgot" style={{ textAlign: "center" }}>
              Back to login
            </Link>
          </div>
        </form>
      ) : (
        <form onSubmit={verifyOtp} noValidate>
          <div className="ems-auth-field">
            <label htmlFor="forgot-otp">OTP</label>
            <input
              id="forgot-otp"
              placeholder="Enter received OTP"
              type="text"
              value={enteredOtp}
              onChange={(e) => setEnteredOtp(e.target.value)}
              className="ems-fm-input"
            />
            {errors.otp && <span className="ems-fm-err">{errors.otp}</span>}
          </div>
          <div className="ems-auth-actions">
            <button type="submit" className="ems-btn ems-primary" disabled={loading}>
              {loading ? <><SpinSVG /> Verifying…</> : "Verify OTP"}
            </button>
          </div>
        </form>
      )}
    </AuthShell>
  );
}

export default ForgotPassword;
